import TermsContent from '../../../components/PrivacyAndTerms/TermsContent';

import Container from './Container';

function Terms() {
  return (
    <Container>
      <TermsContent />
    </Container>
  );
}

export default Terms;
